import { h, Component } from 'preact';

export default class PasswordStrength extends Component {
    constructor() {
        super();
        this.state = {
            meterClass: ''
        }
    }

    componentDidMount() {
        this.setMeterClass(this.props.password);
    }

    componentDidUpdate(prevProps) {
        if (this.props.password !== prevProps.password) {
            this.setMeterClass(this.props.password);
        }
    }

    setMeterClass = password => {
        let characters = 0;
        let capitalletters = 0;
        let loweletters = 0;
        let number = 0;
        let special = 0;
        let total = 0;

        let upperCase= new RegExp('[A-Z]');
        let lowerCase= new RegExp('[a-z]');
        let numbers = new RegExp('[0-9]');
        let specialchars = new RegExp('([!@$%^&*()_+,.?`~{}\\\\|\\/?<>;\'"\\[\\]=-])');

        if (password.length > 8) { characters = 1; } else { characters = 0; }
        if (password.match(upperCase)) { capitalletters = 1} else { capitalletters = 0; }
        if (password.match(lowerCase)) { loweletters = 1}  else { loweletters = 0; }
        if (password.match(numbers)) { number = 1}  else { number = 0; }
        if (password.match(specialchars)) { special = 1}  else { special = 0; }

        if (!password.length) {
            this.setState({ meterClass: '' });
        } else {
            total = characters + capitalletters + loweletters + number + special;
            /* istanbul ignore else */
            if (total === 1) {
                this.setState({ meterClass: 'veryweak' });
            } else if (total === 2) {
                this.setState({ meterClass: 'weak' });
            } else if (total === 3 || total === 4) {
                this.setState({ meterClass: 'medium' });
            } else if (total === 5) {
                this.setState({ meterClass: 'strong' });
            }
        }
    };

    render({},{meterClass}) {
        return(
            <div className='strength_meter'>
                <div className={meterClass}>
                    <span>Password strength</span>
                    <div className='bg-wrapper'>
                        <div className='meter' />
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./node_modules/@webapp/preact-shared/components/create-password-input/password-strength.js